import React from 'react';

import { useOpenDeposit } from 'src/hook';

import StepsOverview from './stepsOverview';
import DropdownCurrency from 'src/components/dropdownCurrency';

const InvoiceOpenDeposit: React.FC = (): JSX.Element => {
  useOpenDeposit();

  return (
    <>
      <StepsOverview />
      <DropdownCurrency />
    </>
  );
};

export default InvoiceOpenDeposit;
